import axios from 'axios';

import { B2B_API_URL } from '@config';
import { AsyncActionCreator } from '@redux/types';
import { Contacts } from '@t/contacts';
import { ContactsFormData } from '@containers/Dashboard/Contacts/Form';

import {
    FETCH_CONTACTS_REQUEST,
    FETCH_CONTACTS_SUCCESS,
    FETCH_CONTACTS_ERROR,
    UPDATE_CONTACTS_REQUEST,
    UPDATE_CONTACTS_SUCCESS,
    UPDATE_CONTACTS_ERROR,
} from './types';

export const fetchContacts: AsyncActionCreator<void, Contacts> = () => async (
    dispatch,
    getState
) => {
    dispatch({
        type: FETCH_CONTACTS_REQUEST,
    });

    const {
        auth: { token },
    } = getState();

    try {
        const { data: contacts } = await axios.get(`${B2B_API_URL}/contacts`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        dispatch({
            type: FETCH_CONTACTS_SUCCESS,
            payload: contacts,
        });

        return contacts;
    } catch (err) {
        if (err instanceof Error) {
            dispatch({
                type: FETCH_CONTACTS_ERROR,
            });

            throw err;
        }
    }
};

export const updateContacts: AsyncActionCreator<
    { values: ContactsFormData },
    Contacts
> = ({ values }) => async (dispatch, getState) => {
    dispatch({
        type: UPDATE_CONTACTS_REQUEST,
    });

    const {
        auth: { token },
    } = getState();

    const newValues = { ...values };

    try {
        const { data: contacts } = await axios.put(
            `${B2B_API_URL}/contacts`,
            newValues,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        dispatch({
            type: UPDATE_CONTACTS_SUCCESS,
            payload: contacts,
        });

        return contacts;
    } catch (err) {
        if (err instanceof Error) {
            dispatch({
                type: UPDATE_CONTACTS_ERROR,
            });

            throw err;
        }
    }
};
